<template>
  <v-list-item link @click="$emit('click')">
    <v-container class="px-0 py-1" fluid>
      <v-row align="center" class="my-0">
        <v-col cols="1" class="py-0">
          <span class="text-truncate">
            {{ item.Id }}
          </span>
        </v-col>

        <v-col cols="2" class="py-0">
          <LeadsStateChip :state="item.State" />
        </v-col>

        <v-col cols="2" class="py-0">
          <v-chip small style="border-radius: 4px;">
            <span class="text-truncate">
              {{ item.LeadType ? item.LeadType.Name : '' }}
            </span>
          </v-chip>
        </v-col>

        <v-col cols="5" class="py-0">
          <span class="note-line">
            {{ item.Note }}
          </span>
        </v-col>

        <v-col cols="2" class="py-0">
          <span class="text-truncate">
            {{ i18nFormatDateTime(item.Modified) }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-list-item>
</template>


<script>
import LeadsStateChip from "./LeadsStateChip.vue";

export default {
  name: "AdminLeadsPage",
  props: {
    item: Object,
  },
  components: {
    LeadsStateChip,
  },

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped>
.note-line {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>